/**
 * GO/src/orderservice/orderservice.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { DeleteOrdersReply } from '../model/deleteOrdersReply';
import { HelloReply } from '../model/helloReply';
import { HelloRequest } from '../model/helloRequest';
import { ImportOrderResult } from '../model/importOrderResult';
import { Order } from '../model/order';
import { OrderAssetsDataList } from '../model/orderAssetsDataList';
import { OrderAssetsList } from '../model/orderAssetsList';
import { OrderHistoryEntry } from '../model/orderHistoryEntry';
import { OrderHistoryEntryList } from '../model/orderHistoryEntryList';
import { OrderID } from '../model/orderID';
import { OrderLine } from '../model/orderLine';
import { OrderLineList } from '../model/orderLineList';
import { OrderList } from '../model/orderList';
import { OrderListParam } from '../model/orderListParam';
import { Response } from '../model/response';
import { SelectOrderReply } from '../model/selectOrderReply';
import { SqlSelectFilter } from '../model/sqlSelectFilter';
import { SystemStatus } from '../model/systemStatus';
import { SystemStatusParam } from '../model/systemStatusParam';
import { UUIDList } from '../model/uUIDList';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class OrderServiceService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public batchOrders(body: OrderListParam, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public batchOrders(body: OrderListParam, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public batchOrders(body: OrderListParam, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public batchOrders(body: OrderListParam, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling batchOrders.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Response>(`${this.configuration.basePath}/v1/batchOrders`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createOrderHistoryEntry(body: OrderHistoryEntry, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public createOrderHistoryEntry(body: OrderHistoryEntry, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public createOrderHistoryEntry(body: OrderHistoryEntry, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public createOrderHistoryEntry(body: OrderHistoryEntry, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createOrderHistoryEntry.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Response>(`${this.configuration.basePath}/v1/createOrderHistoryEntry`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteOrderLine(body: OrderLine, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public deleteOrderLine(body: OrderLine, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public deleteOrderLine(body: OrderLine, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public deleteOrderLine(body: OrderLine, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling deleteOrderLine.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Response>(`${this.configuration.basePath}/v1/deleteOrderLine`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * delete a list of orders
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteOrders(body: OrderListParam, observe?: 'body', reportProgress?: boolean): Observable<DeleteOrdersReply>;
    public deleteOrders(body: OrderListParam, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DeleteOrdersReply>>;
    public deleteOrders(body: OrderListParam, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DeleteOrdersReply>>;
    public deleteOrders(body: OrderListParam, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling deleteOrders.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<DeleteOrdersReply>(`${this.configuration.basePath}/v1/deleteOrders`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSystemStatus(body: SystemStatusParam, observe?: 'body', reportProgress?: boolean): Observable<SystemStatus>;
    public getSystemStatus(body: SystemStatusParam, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SystemStatus>>;
    public getSystemStatus(body: SystemStatusParam, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SystemStatus>>;
    public getSystemStatus(body: SystemStatusParam, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling getSystemStatus.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SystemStatus>(`${this.configuration.basePath}/v1/systemStatus`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Import new  ogosorder file
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importOgosOrder(body: OrderID, observe?: 'body', reportProgress?: boolean): Observable<ImportOrderResult>;
    public importOgosOrder(body: OrderID, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ImportOrderResult>>;
    public importOgosOrder(body: OrderID, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ImportOrderResult>>;
    public importOgosOrder(body: OrderID, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling importOgosOrder.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ImportOrderResult>(`${this.configuration.basePath}/v1/importOgosOrder`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Import old ogosorder file
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importOrder(body: OrderID, observe?: 'body', reportProgress?: boolean): Observable<ImportOrderResult>;
    public importOrder(body: OrderID, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ImportOrderResult>>;
    public importOrder(body: OrderID, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ImportOrderResult>>;
    public importOrder(body: OrderID, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling importOrder.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ImportOrderResult>(`${this.configuration.basePath}/v1/importOrder`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public sayHello(body: HelloRequest, observe?: 'body', reportProgress?: boolean): Observable<HelloReply>;
    public sayHello(body: HelloRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<HelloReply>>;
    public sayHello(body: HelloRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<HelloReply>>;
    public sayHello(body: HelloRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling sayHello.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<HelloReply>(`${this.configuration.basePath}/v1/sayhello`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public sayHelloAgain(body: HelloRequest, observe?: 'body', reportProgress?: boolean): Observable<HelloReply>;
    public sayHelloAgain(body: HelloRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<HelloReply>>;
    public sayHelloAgain(body: HelloRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<HelloReply>>;
    public sayHelloAgain(body: HelloRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling sayHelloAgain.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<HelloReply>(`${this.configuration.basePath}/v1/sayhelloagain`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * select the orderAssets assigned to a bacthEntry
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public selectBatchOrderAssets(body: SqlSelectFilter, observe?: 'body', reportProgress?: boolean): Observable<OrderAssetsList>;
    public selectBatchOrderAssets(body: SqlSelectFilter, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<OrderAssetsList>>;
    public selectBatchOrderAssets(body: SqlSelectFilter, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<OrderAssetsList>>;
    public selectBatchOrderAssets(body: SqlSelectFilter, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling selectBatchOrderAssets.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<OrderAssetsList>(`${this.configuration.basePath}/v1/selectBatchOrderAssets`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * select the orderlines assigned to a bacthEntry
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public selectBatchOrderLines(body: SqlSelectFilter, observe?: 'body', reportProgress?: boolean): Observable<OrderLineList>;
    public selectBatchOrderLines(body: SqlSelectFilter, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<OrderLineList>>;
    public selectBatchOrderLines(body: SqlSelectFilter, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<OrderLineList>>;
    public selectBatchOrderLines(body: SqlSelectFilter, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling selectBatchOrderLines.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<OrderLineList>(`${this.configuration.basePath}/v1/selectBatchOrderLines`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public selectOrderAssets(body: SqlSelectFilter, observe?: 'body', reportProgress?: boolean): Observable<OrderAssetsList>;
    public selectOrderAssets(body: SqlSelectFilter, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<OrderAssetsList>>;
    public selectOrderAssets(body: SqlSelectFilter, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<OrderAssetsList>>;
    public selectOrderAssets(body: SqlSelectFilter, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling selectOrderAssets.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<OrderAssetsList>(`${this.configuration.basePath}/v1/selectOrderAssets`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * this function select orders by Internal Id and return complete order wit orderlines,assets,addresses,....
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public selectOrderById(body: UUIDList, observe?: 'body', reportProgress?: boolean): Observable<OrderList>;
    public selectOrderById(body: UUIDList, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<OrderList>>;
    public selectOrderById(body: UUIDList, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<OrderList>>;
    public selectOrderById(body: UUIDList, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling selectOrderById.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<OrderList>(`${this.configuration.basePath}/v1/selectOrderById`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public selectOrderHistoryEntry(body: SqlSelectFilter, observe?: 'body', reportProgress?: boolean): Observable<OrderHistoryEntryList>;
    public selectOrderHistoryEntry(body: SqlSelectFilter, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<OrderHistoryEntryList>>;
    public selectOrderHistoryEntry(body: SqlSelectFilter, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<OrderHistoryEntryList>>;
    public selectOrderHistoryEntry(body: SqlSelectFilter, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling selectOrderHistoryEntry.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<OrderHistoryEntryList>(`${this.configuration.basePath}/v1/selectOrderHistoryEntry`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public selectOrderLines(body: SqlSelectFilter, observe?: 'body', reportProgress?: boolean): Observable<OrderLineList>;
    public selectOrderLines(body: SqlSelectFilter, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<OrderLineList>>;
    public selectOrderLines(body: SqlSelectFilter, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<OrderLineList>>;
    public selectOrderLines(body: SqlSelectFilter, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling selectOrderLines.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<OrderLineList>(`${this.configuration.basePath}/v1/selectOrderLines`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * return order data WITHOUT orderlines,orderassets and addresses this function is used to display a list of orders in a grid
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public selectOrders(body: SqlSelectFilter, observe?: 'body', reportProgress?: boolean): Observable<SelectOrderReply>;
    public selectOrders(body: SqlSelectFilter, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SelectOrderReply>>;
    public selectOrders(body: SqlSelectFilter, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SelectOrderReply>>;
    public selectOrders(body: SqlSelectFilter, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling selectOrders.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SelectOrderReply>(`${this.configuration.basePath}/v1/selectOrders`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setOrderStatus(body: Order, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public setOrderStatus(body: Order, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public setOrderStatus(body: Order, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public setOrderStatus(body: Order, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling setOrderStatus.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Response>(`${this.configuration.basePath}/v1/setOrderStatus`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * select the save the data for the order assets
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateBatchOrderAssetsData(body: OrderAssetsDataList, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public updateBatchOrderAssetsData(body: OrderAssetsDataList, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public updateBatchOrderAssetsData(body: OrderAssetsDataList, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public updateBatchOrderAssetsData(body: OrderAssetsDataList, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateBatchOrderAssetsData.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Response>(`${this.configuration.basePath}/v1/updateBatchOrderAssetsData`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * update the orderlines asigned to a batchEntry
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateBatchOrderLines(body: OrderLineList, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public updateBatchOrderLines(body: OrderLineList, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public updateBatchOrderLines(body: OrderLineList, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public updateBatchOrderLines(body: OrderLineList, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateBatchOrderLines.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Response>(`${this.configuration.basePath}/v1/updateBatchOrderLines`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateOrderLine(body: OrderLine, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public updateOrderLine(body: OrderLine, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public updateOrderLine(body: OrderLine, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public updateOrderLine(body: OrderLine, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateOrderLine.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Response>(`${this.configuration.basePath}/v1/updateOrderLine`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
